export const PageHeader = ({ code, label, title, subtitle }) => {
  return (
    <header className="border-b border-[#27272A]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="label-mono text-neutral-500">{code}</div>
            <h1 className="font-display font-black text-3xl lg:text-5xl mt-2">
              {title}
            </h1>
          </div>
          <div className="label-mono text-neon">{label}</div>
        </div>
        <p className="text-neutral-400 max-w-2xl text-base sm:text-lg leading-relaxed">
          {subtitle}
        </p>
      </div>
    </header>
  );
};

export default PageHeader;
